import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Bell, X } from 'lucide-react';
import { isPushSupported, isPushSubscribed, subscribeToPush } from '../services/pushNotifications';

const VISIT_KEY = 'tsi_visit_count';
const DISMISS_KEY = 'tsi_push_dismissed';

export default function PushBanner() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (dismissed) return;
    if (!isPushSupported()) return;

    const count = parseInt(localStorage.getItem(VISIT_KEY) || '0', 10) + 1;
    localStorage.setItem(VISIT_KEY, String(count));

    if (count < 3) return;

    isPushSubscribed().then((subscribed) => {
      if (!subscribed) setShow(true);
    });
  }, []);

  const handleAllow = async () => {
    const ok = await subscribeToPush();
    setShow(false);
    if (!ok) localStorage.setItem(DISMISS_KEY, 'true');
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem(DISMISS_KEY, 'true');
  };

  if (!show) return null;

  return (
    <div className="fixed top-20 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 bg-surface-0 border border-primary-200 shadow-elevated rounded-xl p-4 flex items-start gap-3">
      <Bell size={24} className="text-primary-600 flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="text-sm font-medium text-surface-800">{t('push.enableNotifications')}</p>
        <div className="flex gap-2 mt-3">
          <button onClick={handleAllow} className="btn btn-primary text-xs py-1.5 px-4">
            {t('push.subscribed').replace('!', '')}
          </button>
          <button onClick={handleDismiss} className="btn bg-surface-100 text-surface-600 text-xs py-1.5 px-4">
            {t('push.askLater')}
          </button>
        </div>
      </div>
      <button onClick={handleDismiss} className="text-surface-400 hover:text-surface-600 flex-shrink-0">
        <X size={16} />
      </button>
    </div>
  );
}
